module.exports = __webpack_public_path__ + "static/media/Pen.368029f8.m4a";